$(document).ready(function() {
  
  
    $('.testimonial-slick').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows:true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
	});
  
  
  	$(window).on('load resize orientationchange', function() {
        $('.banner-slick-mobile').each(function(){
            var $carousel = $(this);
            if ($(window).width() > 750) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else{
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        arrows: true, 
                        dots: true
                    });
                }
            }
        });
    });

    let mobileMenu = $("#menu-drawer");
    let header = $("#shopify-section-header");
    let announcementHeight = $("#shopify-section-announcement-bar").height();
    
    let headerHeight = header.height();
    let space = headerHeight + announcementHeight;

    mobileMenu.height(document.documentElement.clientHeight - space);

    // console.log(document.documentElement.clientHeight);

    $(window).scroll(function(){
      let mobileMenu = $("#menu-drawer");
      let header = $("#shopify-section-header");
      let announcementHeight = $("#shopify-section-announcement-bar").height();
      let space = 0;

      if( header.hasClass("shopify-section-header-sticky") ) {
        space = header.height();
      } else {
        space = header.height() + announcementHeight;
      }

      // console.log(document.documentElement.clientHeight);

      mobileMenu.height(document.documentElement.clientHeight - space);
    });

    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
});

document.querySelectorAll('.expandable-content').forEach(function(expand) {
  expand.addEventListener('click', function() {
    this.classList.toggle('expanded-content');

    if (this.classList.contains('expanded-content')) {
      this.querySelector('.expandable-content--toggle-text').innerHTML = this.querySelector('.expandable-content--toggle-text').getAttribute('data-view-less');
      this.style.maxHeight = 'none';
      this.querySelector('.rte').style.marginBottom = this.querySelector('.expandable-content--toggle').offsetHeight + 'px';
      console.log(this.querySelector('.expandable-content--toggle').offsetHeight);
    } else {
      this.querySelector('.expandable-content--toggle-text').innerHTML = this.querySelector('.expandable-content--toggle-text').getAttribute('data-view-more');
      if (this.hasAttribute('style')) {
        this.removeAttribute('style');
      }
      if (this.querySelector('.rte').hasAttribute('style')) {
        this.querySelector('.rte').removeAttribute('style');
      }
    }
  });
});
